import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { Button } from 'v5/design-system/Button';
import { Skeleton } from 'v5/design-system/Skeleton';

interface CompletedRegistrationViewProps {
  firstName?: string;
  isLoading: boolean;
  onNavigate: () => void;
}

export const CompletedRegistrationView: React.FC<
  CompletedRegistrationViewProps
> = ({ firstName, isLoading, onNavigate }) => {
  const { t } = useTranslation('v1-features');

  const heading = firstName
    ? t('CompletedRegistration.headerWithName', { firstName })
    : t('CompletedRegistration.header');

  return (
    <div className="tailwind-root contents">
      <div className="flex justify-center w-[90vw] sm:w-[70vw] flex-col sm:flex-row">
        <div className="self-center w-[90%] sm:w-[50%]">
          <AnimatePresence mode="popLayout">
            {isLoading ? (
              <motion.div
                key="loading"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="space-y-6"
              >
                <Skeleton className="h-10 w-3/4" />
                <Skeleton className="h-6 w-full" />
                <Skeleton className="h-6 w-5/6" />
                <Skeleton className="h-12 w-40 mt-8" />
              </motion.div>
            ) : (
              <motion.div
                key="content"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
              >
                <h2 className="text-2xl font-semibold text-fg-default mb-4">
                  {heading}
                </h2>
                <p className="text-2xl text-fg-default mb-8">
                  {t('CompletedRegistration.description')}
                </p>
                <Button variant="primaryAlt" size="lg" onClick={onNavigate}>
                  {t('CompletedRegistration.letsGo')}
                </Button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};
